import { render, staticRenderFns } from "./FeedNotificationPanel.vue?vue&type=template&id=7f0e2e1f&"
import script from "./FeedNotificationPanel.vue?vue&type=script&lang=js&"
export * from "./FeedNotificationPanel.vue?vue&type=script&lang=js&"
import style0 from "./FeedNotificationPanel.vue?vue&type=style&index=0&id=7f0e2e1f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports